// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import DisplayImage from "./image.jpg";

const iframeUrl =
  process.env.REACT_APP_ENV_TYPE === "production"
    ? "https://www.smh.com.au/interactive/modules/before-after-image-slider/index.html?resizable=true"
    : "https://www.smh.com.au/interactive/modules/before-after-image-slider/stage/index.html?configUrl=./example-config.json&resizable=true";

const description =
  "A widget that allows the user to compare two images, sliding one on top of the other to bear witness to some change.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Before-after image slider",
  id: "before-after-image-slider",
  groupsWithAccess: ["specialist_user", "editor_user"],
  linkPrefix: "/interactives",
  tags: ["Configurable"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot: iframeUrl,
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "BeforeAfterImageSliderConfigTool" */ "app/components/tools/BeforeAfterImageSliderConfigTool/BeforeAfterImageSliderConfigTool"),
    loading: DynamicImportLoader,
    modules: ["BeforeAfterImageSliderConfigTool"]
  })
};

export default CONFIG;
